import React from 'react';
import { Box, Chip } from '@mui/material';
import { fmtInt } from '../../../utils/buyerInsightsFormat';

// View chips with their counts (spec §2.2). Exactly one active; clicking it again does nothing.
// On = primary filled, off = white with a grey border. 40 px tall on narrow screens, 32 wide.
// `secondary` is the smaller second row (Discount timing groups): on = primary outline.
const ViewChips = ({ views, counts, active, onSelect, isWide, loading, ariaLabel = 'View', secondary = false }) => (
  <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 1 }} role="group" aria-label={ariaLabel}>
    {views.map((v) => {
      const count = counts && counts[v.key] !== undefined ? counts[v.key] : null;
      const isActive = v.key === active;
      return (
        <Chip
          key={v.key}
          aria-pressed={isActive}
          onClick={() => {
            if (!isActive) onSelect(v.key, count);
          }}
          color={isActive ? 'primary' : 'default'}
          variant={isActive && !secondary ? 'filled' : 'outlined'}
          label={
            <Box component="span" sx={{ display: 'inline-flex', alignItems: 'baseline', gap: 0.75 }}>
              <span>{v.label}</span>
              <Box
                component="span"
                sx={{ fontWeight: 600, opacity: loading ? 0.6 : 1, color: isActive ? 'inherit' : 'text.secondary' }}
              >
                {count === null ? '—' : fmtInt(count)}
              </Box>
            </Box>
          }
          sx={{
            height: secondary ? (isWide ? 28 : 36) : isWide ? 32 : 40,
            fontSize: secondary ? 13 : 14,
            bgcolor: isActive ? (secondary ? 'rgba(25, 118, 210, 0.08)' : undefined) : '#fff',
            borderColor: isActive ? undefined : '#bdbdbd',
            '& .MuiChip-label': { px: 1.5 },
          }}
        />
      );
    })}
  </Box>
);

export default ViewChips;
